<template>
    <div class="optionOddsGroup notranslate">
        <template v-if="pointDisplay">
            <span class="optionOdds optionOdds-point" v-bind:class="{ 'optionOdds-change': isPointChange }">{{ pointDisplay }}</span>
            <span class="optionOdds optionOdds-at">@</span>
        </template>
        <template v-if="liveScoreDisplay">
            <span
                class="optionOdds optionOdds-score"
                v-bind:class="{ 'optionOdds-change': isScoreChange }"
                data-testid="ticket-live-score"
            >{{ liveScoreDisplay }}</span>
            <span class="optionOdds optionOdds-at">@</span>
        </template>
        <template v-if="priceDisplay">
            <span class="optionOdds optionOdds-price" v-bind:class="{ 'optionOdds-change': isPriceChange }">
                <del v-if="isPriceChange" class="optionOddsPrice-old">{{ oldPriceDisplay }}</del>
                <strong
                    class="optionOddsPrice"
                    v-bind:class="{ 'optionOddsPrice-negative': isNegativePrice }"
                    data-testid="ticket-price"
                >{{ priceDisplay }}</strong>
                <div
                    v-if="isPriceChange"
                    class="oddsStates"
                    v-bind:class="oddsStatesClass"
                >
                    <div class="triangle" />
                </div>
            </span>
        </template>
    </div>
</template>

<script lang="ts" setup>
    import { computed } from 'vue';
    import { TicketContext } from '@/components/betSlip/TicketContext';
    import { PriceChangeStatus } from '@/interface/enum';

    const {
        pointDisplay,
        isPointChange,
        priceDisplay,
        oldPriceDisplay,
        isPriceChange,
        priceChangeStatus,
        isNegativePrice,
        liveScoreDisplay,
        isScoreChange,
    } = TicketContext.inject();

    const oddsStatesClass = computed(() => ({
        'oddsStates-rise': priceChangeStatus.value === PriceChangeStatus.Rise,
        'oddsStates-drop': priceChangeStatus.value === PriceChangeStatus.Drop,
    }));
</script>

<style lang="scss" scoped>
    @import "@/components/betSlip/Ticket";
</style>
